import * as date from 'Utils/date'
import { Fragment } from 'react'
import { useFilterContext } from './context'
import { DateRangePicker } from 'Src/b/components/DatePicker'
import ReactSelect from 'Src/b/components/ReactSelect'
import {
  ADMIN_FEEDBACK_FILTER_OPTIONS,
  ALL_OPTION_VALUE,
  BOT_RESPONSE_FILTER_OPTIONS,
  VISITOR_FEEDBACK_FILTER_OPTIONS
} from 'Src/constants'

const DEFAULT_PAGE_SIZE = 10
const DEFAULT_PAGE = 1
const DATE_FORMAT = 'MM-DD-YYYY'

const isValidBotResponse = (valueForCheck) => {
  return BOT_RESPONSE_FILTER_OPTIONS.some(({ value }) => value === valueForCheck)
}
const isValidAdminFeedback = (valueForCheck) => {
  return ADMIN_FEEDBACK_FILTER_OPTIONS.some(({ value }) => value === valueForCheck)
}
const isValidVisitorFeedback = (valueForCheck) => {
  return VISITOR_FEEDBACK_FILTER_OPTIONS.some(({ value }) => value === valueForCheck)
}

export const parseFiltersFromURL = () => {
  const params = new URLSearchParams(location.search)

  const paramsSize = params.get('size') || DEFAULT_PAGE_SIZE
  const paramsPage = params.get('page') || DEFAULT_PAGE

  const page = isNaN(paramsPage) ? DEFAULT_PAGE : parseInt(paramsPage)
  const size = isNaN(paramsSize) ? DEFAULT_PAGE_SIZE : parseInt(paramsSize)

  const paramsStartDate = params.get('start_date')
  const paramsEndDate = params.get('end_date')
  const paramsBotResponse = params.get('prediction_outcome')
  const paramsAdminFeedback = params.get('admin_feedback')
  const paramsVisitorFeedback = params.get('visitor_feedback')

  const dateRange = []
  if (date.isValid(paramsStartDate)) {
    dateRange[0] = date.format(paramsStartDate, DATE_FORMAT)
  }
  if (date.isValid(paramsEndDate) && dateRange[0]) {
    dateRange[1] = date.format(paramsEndDate, DATE_FORMAT)
  }

  const botResponse = isValidBotResponse(paramsBotResponse) ? paramsBotResponse : ''
  const adminFeedback = isValidAdminFeedback(paramsAdminFeedback) ? paramsAdminFeedback : ''
  const visitorFeedback = isValidVisitorFeedback(paramsVisitorFeedback) ? paramsVisitorFeedback : ''

  const queryParams = {
    page,
    size,
    dateRange,
    botResponse,
    adminFeedback,
    visitorFeedback
  }

  return queryParams
}

export const getInitialApiSearchParams = (params) => {
  const initialParams = {
    offset: (params.page - 1) * params.size,
    limit: params.size
  }

  const [startDate, endDate] = params.dateRange
  if (startDate) {
    initialParams.start_date = startDate
  }

  if (endDate) {
    initialParams.end_date = endDate
  }

  if (params.adminFeedback) {
    initialParams.admin_feedback = params.adminFeedback
  }

  if (params.botResponse) {
    initialParams.prediction_outcome = params.botResponse
  }

  if (params.visitorFeedback) {
    initialParams.visitor_feedback = params.visitorFeedback
  }

  return initialParams
}

const DateRangeFilter = () => {
  const { resetPage, dateRange, setDateRange } = useFilterContext()

  const handleChange = (range = []) => {
    resetPage()
    setDateRange(range || [])
  }

  return <DateRangePicker maxDate={new Date()} value={dateRange} onChange={handleChange} />
}

const BotResponseFilter = () => {
  const { resetPage, botResponse, setBotResponse } = useFilterContext()
  const value = BOT_RESPONSE_FILTER_OPTIONS.find(({ value }) => value === botResponse)

  const placeHolder = `Response`
  const handleChange = ({ value }) => {
    resetPage()
    setBotResponse(value)
  }

  const handleOptionLabelFormatting = ({ label }, { context }) =>
    context === 'menu' ? label : `${placeHolder}: ${label}`

  return (
    <ReactSelect
      value={value}
      onChange={handleChange}
      isClearable={false}
      options={BOT_RESPONSE_FILTER_OPTIONS}
      formatOptionLabel={handleOptionLabelFormatting}
      getOptionLabel={(option) => option.label}
      getOptionValue={(option) => option.value}
      placeholder={placeHolder}
      isOptionSelected={({ value }) => value === botResponse}
      controlShouldRenderValue={botResponse !== ALL_OPTION_VALUE}
    />
  )
}

const VisitorFeedbackFilter = () => {
  const { resetPage, visitorFeedback, setVisitorFeedback } = useFilterContext()
  const value = VISITOR_FEEDBACK_FILTER_OPTIONS.find(({ value }) => value === visitorFeedback)

  const placeHolder = `Visitor Feedback`
  const handleChange = ({ value }) => {
    resetPage()
    setVisitorFeedback(value)
  }

  const handleOptionLabelFormatting = ({ label }, { context }) =>
    context === 'menu' ? label : `${placeHolder}: ${label}`

  return (
    <ReactSelect
      value={value}
      onChange={handleChange}
      isClearable={false}
      options={VISITOR_FEEDBACK_FILTER_OPTIONS}
      formatOptionLabel={handleOptionLabelFormatting}
      getOptionLabel={(option) => option.label}
      getOptionValue={(option) => option.value}
      placeholder={placeHolder}
      isOptionSelected={({ value }) => value === visitorFeedback}
      controlShouldRenderValue={visitorFeedback !== ALL_OPTION_VALUE}
    />
  )
}

const AdminFeedbackFilter = () => {
  const { resetPage, adminFeedback, setAdminFeedback } = useFilterContext()
  const value = ADMIN_FEEDBACK_FILTER_OPTIONS.find(({ value }) => value === adminFeedback)

  const placeHolder = `Content Feedback`

  const handleChange = ({ value }) => {
    resetPage()
    setAdminFeedback(value)
  }

  const handleOptionLabelFormatting = ({ label }, { context }) =>
    context === 'menu' ? label : `${placeHolder}: ${label}`

  return (
    <ReactSelect
      value={value}
      onChange={handleChange}
      isClearable={false}
      options={ADMIN_FEEDBACK_FILTER_OPTIONS}
      formatOptionLabel={handleOptionLabelFormatting}
      getOptionLabel={(option) => option.label}
      getOptionValue={(option) => option.value}
      placeholder={placeHolder}
      isOptionSelected={({ value }) => value === adminFeedback}
      controlShouldRenderValue={adminFeedback !== ALL_OPTION_VALUE}
    />
  )
}

const Filters = () => {
  return (
    <Fragment>
      <DateRangeFilter />
      <BotResponseFilter />
      <VisitorFeedbackFilter />
      <AdminFeedbackFilter />
    </Fragment>
  )
}

export default Filters
